import { FC, memo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { AppAutocomplete, AwesomeNodePath } from '@/common/components';
import { AppAutocompleteComponentProps } from '@/common/interfaces';
import { parseSelectData } from '@/common/utils';

import { useAutocompletePageNodesQuery } from '@/modules/Pages';

interface Props extends AppAutocompleteComponentProps {
  siteId: string;
}

export const PageNodesAllAutocomplete: FC<Props> = memo(({ siteId, ...props }) => {
  const location = useLocation();
  const { nodeId } = useParams();

  return (
    <AppAutocomplete<typeof useAutocompletePageNodesQuery>
      {...props}
      queryArgs={[siteId]}
      optionItemRender={({ path }) => <AwesomeNodePath path={path} />}
      options={(data) =>
        parseSelectData(
          data?.filter(({ id, path }) => (path === '/' || location.pathname.includes('create') ? true : id !== nodeId)),
          { value: 'id', label: 'path' },
        )
      }
      notFoundDescription="Немає нод для цього сайту"
      placeholder="Знайдіть структурну ноду ноду"
      query={useAutocompletePageNodesQuery}
    />
  );
});
